import fetch from './lib/fetch'

export async function processCharge(rechargeId: string, chargeId: number) {
  return await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/protected/subscriptions/${rechargeId}/process/${chargeId}`,
    {
      method: 'POST',
    },
  )
}
